import React from 'react';
import { setCookieConsent, COOKIE_CATEGORIES } from '../utils/cookies';
import { initializeAnalytics } from '../utils/analytics';
import Modal from './Modal';
import './CookieBanner.css';

function CookieBanner({ isOpen, onClose, onOpenPreferences, requireChoice = false }) {

  const handleAcceptAll = () => {
    setCookieConsent({
      [COOKIE_CATEGORIES.ESSENTIAL]: true,
      [COOKIE_CATEGORIES.FUNCTIONAL]: true,
      [COOKIE_CATEGORIES.ANALYTICS]: true
    });
    // Initialize analytics after consent
    initializeAnalytics();
    if (onClose) {
      onClose();
    }
  };

  const handleOnlyNecessary = () => {
    setCookieConsent({
      [COOKIE_CATEGORIES.ESSENTIAL]: true,
      [COOKIE_CATEGORIES.FUNCTIONAL]: false,
      [COOKIE_CATEGORIES.ANALYTICS]: false
    });
    if (onClose) {
      onClose();
    }
  };

  const handleCookieSettings = () => {
    if (onOpenPreferences) {
      onOpenPreferences();
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="modal-wide" requireChoice={requireChoice}>
      <div className="cookie-banner">
        <div className="cookie-banner-text">
          <h2 className="cookie-banner-title">We value your privacy</h2>
          <p className="cookie-banner-description">
            We use cookies to enhance your experience, remember your preferences, and understand how the platform is used.
            You can accept all cookies, choose only essential cookies, or customize your preferences. You can change or withdraw your consent at any time via{' '}
            <button 
              className="cookie-banner-link-button"
              onClick={handleCookieSettings}
            >
              Cookie settings
            </button>.
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button 
            className="cookie-banner-button cookie-banner-button-secondary"
            onClick={handleOnlyNecessary}
          >
            Only necessary
          </button>
          <button 
            className="cookie-banner-button cookie-banner-button-customize"
            onClick={handleCookieSettings}
          >
            Cookie settings
          </button>
          <button 
            className="cookie-banner-button cookie-banner-button-primary"
            onClick={handleAcceptAll}
          >
            Accept all
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default CookieBanner;
